import View from './View';

export { default as View, getSearchNothingFoundStyles } from './View';

export default View;
